export enum UpgrateStatus {
  success = "success",
  cancel = "cancel",
  error = "error",
}

export const UpgrateStatusMap = {
  [UpgrateStatus.success]: '成功',
  [UpgrateStatus.cancel]: '取消',
  [UpgrateStatus.error]: '失败'
};
